import { SchmancyElement } from '@schmancy/mixins/index'
import { property } from 'lit/decorators.js'

/**
 * Abstract base for schmancy skeleton presets.
 * Concrete presets extend this class and implement their unit template;
 * they must not re-declare `count` under any alias.
 */
export abstract class SkeletonPreset extends SchmancyElement {
	@property({ type: Number }) count = 3

	connectedCallback(): void {
		super.connectedCallback()
		// Single announce point for the loading region — one status, not one per inner shape.
		this.setAttribute('role', 'status')
		this.setAttribute('aria-busy', 'true')
		/**
		 * A name naming the work — "Loading orders", "Searching venues" — is the
		 * consumer's to give, because only the call site knows what is being waited
		 * on, and it gives it with the platform attribute rather than a prop that
		 * would shadow it. The bare "Loading" is the floor for a region that names
		 * nothing, so overwriting a supplied name would leave the call site no way
		 * to say what it is waiting for.
		 */
		if (!this.hasAttribute('aria-label') && !this.hasAttribute('aria-labelledby')) {
			this.setAttribute('aria-label', 'Loading')
		}
	}
}
